export function saveBlobAsFile(blob: Blob, filenameFallback: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filenameFallback;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function extractFilenameFromContentDisposition(cd?: string | null) {
  if (!cd) return null;
  const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
  return decodeURIComponent(match?.[1] ?? match?.[2] ?? "");
}

export function sanitizeFilePart(s: string) {
  return (s ?? "")
    .replace(/[\\/:*?"<>|]/g, "") 
    .replace(/\s+/g, " ")     
    .trim();
}
